module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/190/assets/images/63a144b61196849f3989daf1bea09674.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_sort_up.svg
// module id = cDhN
// module chunks = 1